import {
  APICallState,
  LottieLoadingSpinner,
  PanelSeparator,
  Selectors,
  useIsDesktop,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import PrivacyControlsModule from 'components/PrivacyControlsModule';
import ResponsibleGamingModule from 'components/ResponsibleGamingModule';
import SaleOfInformationModule from 'components/SaleOfInformationModule';
import ConnectedSubscriptionsModule from 'containers/ConnectedSubscriptionsModule';
import ConnectedLeaderBoardPreferences from 'containers/LeaderBoardPreferences';
import {View} from 'native-base';
import React from 'react';

export interface CommunicationsTabProps {
  setTabToProfile: () => void;
}

const CommunicationsTab: React.FC<CommunicationsTabProps> = ({
  setTabToProfile,
}) => {
  const getGuestProfileCallState = useWidgetState(
    Selectors.getGuestProfileCallStateSelector
  ) as APICallState;
  const isDesktop = useIsDesktop();

  return [APICallState.SUCCESS, APICallState.ERROR].includes(
    getGuestProfileCallState
  ) ? (
    <>
      <ConnectedSubscriptionsModule setTabToProfile={setTabToProfile} />
      <PanelSeparator />
      <PrivacyControlsModule />
      <PanelSeparator />
      <SaleOfInformationModule />
      <PanelSeparator />
      <ConnectedLeaderBoardPreferences />
      <PanelSeparator />
      <ResponsibleGamingModule />
    </>
  ) : (
    <View
      flex={1}
      justifyContent="center"
      alignItems="center"
      minH={isDesktop ? '450px' : '434px'}
      backgroundColor={isDesktop ? 'white' : undefined}
      shadow={isDesktop ? 0 : undefined}>
      <LottieLoadingSpinner />
    </View>
  );
};

export default CommunicationsTab;
